import axios from 'axios';

import socket from '../../services/socket';
import router from '../../router';
import notificator from '../../services/notificator';

// TODO: extract
const generateEmptyUser = () => ({
  id: '',
  username: '',
  email: '',
  roles: [],
  isVerified: false,
});

export default {
  namespaced: true,
  state: {
    gameId: null,
    user: generateEmptyUser(),
    tokenRenewalIntervalStarted: false,
    tokenRenewalIntervalHandle: null,
  },
  getters: {
    user: (state) => state.user,
    isAuth: (state) => !!state.user.id,
  },
  mutations: {
    setUser: (state, userData) => (state.user = userData),
    setGameId: (state, gameId) => (state.gameId = gameId),
  },
  actions: {
    updateProfile: async ({ dispatch }, profileData) => {
      try {
        const { data } = await axios.put('/user/profile', profileData);

        await dispatch('setToken', data.token);
        await dispatch('fetchUser');

        router.push({ name: 'lobby' });

        notificator.success('Your profile has been updated!');
      } catch (e) {
        console.log({ ...e });

        notificator.error('Could not update your profile.');
      }
    },
    getPasswordResetToken: async (ctx, payload) => {
      try {
        await axios.post('/user/forgot-password', payload);

        router.push({ name: 'userLogin' });

        notificator.success('Your password reset link has been sent to your email!');
      } catch (e) {
        console.log({ ...e });

        notificator.error('Could not reset your password.');
      }
    },
    resetPassword: async (ctx, payload) => {
      try {
        await axios.put('/user/reset-password', payload.formFields, {
          headers: { Authorization: 'Bearer ' + payload.token },
        });

        router.push({ name: 'userLogin' });

        notificator.success('Your password has been reset successfully!');
      } catch (e) {
        console.log({ ...e });

        notificator.error('Could not reset your password.');
      }
    },
    logOut: ({ dispatch }) => {
      dispatch('unsetToken');

      router.push({ name: 'userLogin' });
    },
    changePassword: async ({ dispatch, state }, changePasswordData) => {
      try {
        await axios.put('/user/change-password', changePasswordData);

        router.push({ name: 'lobby' });

        notificator.success('Your password has been successfully changed!');
      } catch (e) {
        console.log({ ...e });

        notificator.error('Could not change your password.');
      }
    },
    register: async ({ dispatch, state }, registerData) => {
      try {
        const { data } = await axios.post('/user/register', registerData);

        dispatch('setToken', data.token);
        dispatch('startTokenRenewalInterval');
        await dispatch('fetchUser');

        state.gameId
          ? router.push({ name: 'game', params: { id: state.gameId } })
          : router.push({ name: 'lobby' });
      } catch (e) {
        console.log({ ...e });

        notificator.error('There was an error when registering your account.');
      }
    },
    logIn: async ({ dispatch, state }, loginData) => {
      try {
        const { data } = await axios.post('/user/login', loginData);

        dispatch('setToken', data.token);
        dispatch('startTokenRenewalInterval');
        await dispatch('fetchUser');

        state.gameId
          ? router.push({ name: 'game', params: { id: state.gameId } })
          : router.push({ name: 'lobby' });
      } catch (e) {
        console.log({ ...e });

        notificator.error('Specified credentials are invalid.');
      }
    },
    tryAutoLogin: async ({ dispatch, getters }) => {
      const token = localStorage.getItem('token');

      if (token && !getters.isAuth) {
        // token needs to be sent,
        // for renewToken to work
        dispatch('setToken', token);
        dispatch('startTokenRenewalInterval');

        await dispatch('renewToken');
        await dispatch('fetchUser');
      }
    },
    renewToken: async ({ dispatch }) => {
      try {
        const { data } = await axios.get('/user/renew-token');

        await dispatch('setToken', data.token);
      } catch (e) {
        console.log({ ...e });

        dispatch('unsetToken');

        router.push({ name: 'userLogin' });
      }
    },
    fetchUser: async ({ commit }) => {
      try {
        const { data } = await axios.get('/user/authenticate');

        commit('setUser', data.user);
      } catch (e) {
        console.log({ ...e });

        router.push({ name: 'userLogin' });
      }
    },
    startTokenRenewalInterval: ({ state, dispatch }) => {
      if (state.tokenRenewalIntervalStarted) return;

      state.tokenRenewalIntervalStarted = true;

      state.tokenRenewalIntervalHandle = setInterval(() => dispatch('renewToken'), 1000 * 60 * 10);
    },
    setToken: (_, token) => {
      localStorage.setItem('token', token);

      if (socket.isInit()) {
        socket.emitUpdateToken(token);
      }

      axios.defaults.headers.common['authorization'] = `Bearer ${token}`;
    },
    unsetToken: ({ state, commit }) => {
      commit('setUser', generateEmptyUser());

      localStorage.removeItem('token');

      if (socket.isInit()) {
        socket.emitUpdateToken(null);
      }

      delete axios.defaults.headers.common['authorization'];

      state.tokenRenewalIntervalStarted = false;

      clearInterval(state.tokenRenewalIntervalHandle);
    },
  },
};
